import { IsoString } from 'models';
import { Moment } from 'moment';
import { IResponse } from 'modules/admin-panel/pages/results/models';
import { IReminderFrequencyTypes } from 'modules/admin-panel/pages/templates/models';

export interface ISurveyTrackingData {
	id: string;
	name: string;
	clientId: string;
	canEditEmailTemplates: boolean;
	surveyRounds: ISurveyTrackingRound[];
}

export interface ISurveyTrackingList extends IResponse {
	content: ISurveyTrackingData[];
}

export interface IReminders {
	sent: number;
	allSent: boolean;
	expected: number;
}

export interface ISurveyTrackingRound {
	id: string;
	status: ISurveyRoundStatus;
	startDate: IsoString;
	startTime: IsoString;
	endDate: IsoString;
	reminders?: IReminders;
	invited: null | number;
	completed: null | number;
	reminded: null | number;
	inProgressAmount: null | number;
	marginOfError: number | null;
	surveyDetailedInformationList: null | ISurveyTrackingDetail[];
}

export enum SurveyTrackingDetails {
	country = 'country',
	city = 'city',
	sent = 'sent',
	invited = 'invited',
	sentReminders = 'sentReminders',
	inProgress = 'inProgress',
	completed = 'completed',
	responseRate = 'responseRate',
	sendingDateTime = 'sendingDateTime',
}

export interface ISurveyTrackingDetail {
	[SurveyTrackingDetails.country]: string;
	[SurveyTrackingDetails.city]: string;
	[SurveyTrackingDetails.sent]: number;
	[SurveyTrackingDetails.invited]: number;
	[SurveyTrackingDetails.sentReminders]: number;
	[SurveyTrackingDetails.inProgress]: number;
	[SurveyTrackingDetails.completed]: number;
	[SurveyTrackingDetails.responseRate]: number;
	[SurveyTrackingDetails.sendingDateTime]: IsoString;
}

export enum ISurveyRoundStatus {
	PLANNED = 'PLANNED',
	ONGOING = 'ONGOING',
	CLOSED = 'CLOSED',
	CANCELLED = 'CANCELLED',
}

export interface INotificationPayload {
	surveyId: string;
	roundId: string;
	country?: string;
	city?: string;
}

export interface IRound {
	offices?: string[];
	sendRespondentCount?: string;
	startDate?: Moment;
	endDate?: Moment;
	sendingTime?: Moment;
	remindersFrequency?: IReminderFrequencyTypes;
}

export interface ISurveyRoundPayload {
	id: string;
	offices?: string[];
	sendRespondentCount?: number;
	startDate?: string;
	endDate?: string;
	sendingTime?: string;
	isDailyReminders?: boolean;
}

export interface ISurveyRoundResponse extends Required<ISurveyRoundPayload> {
	status: ISurveyRoundStatus;
}

export interface IRoundDates extends Partial<ISurveyRoundPayload> {
	startDate: string;
	sendingTime: string;
	endDate: string;
}
